import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project-imports
// import axios from 'utils/axios';

// types
import { MenuProps, NavItemType } from 'types/menu';

// initial state
const initialState: MenuProps = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  selectedID: null,
  drawerOpen: true,
  componentDrawerOpen: true,
  menuDashboard: {},
  error: null
};

// ==============================|| SLICE - MENU ||============================== //

export const fetchDashboard = createAsyncThunk('', async () => {
  // const response = await axios.get('/api/dashboard');
  const dashboard: NavItemType|any = {
    id: 'nl-dashboard',
    title: 'dashboard',
    type: 'group',
    icon: 'dashboard',
    children: [
      {
        id: 'dashboard',
        title: 'dashboard',
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
        breadcrumbs: false
        // children: [
        //   {
        //     id: 'default',
        //     title: 'dashboard',
        //     type: 'item',
        //     url: '/dashboard',
        //     breadcrumbs: false
        //   },
          // {
          //   id: 'analytics',
          //   title: 'analytics',
          //   type: 'item',
          //   url: '/dashboard/analytics',
          //   disabled:true
          // }
        // ]
      },
    ]
  };
  return  { dashboard: dashboard };
});

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeID(state, action) {
      state.selectedID = action.payload;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },

    getMenuSuccess(state, action) {
      state.menuDashboard = action.payload;
    },

    hasError(state, action) {
      state.error = action.payload;
    }
  },

  extraReducers(builder) {
    builder.addCase(fetchDashboard.fulfilled, (state, action) => {
      state.menuDashboard = action.payload.dashboard;
    });
  }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer, activeID } = menu.actions;
